import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

interface LocationState {
  scrollTop?: boolean;
}

function ScrollToAnchor() {
  const location = useLocation();
  const lastHash = useRef('');
  const retryCount = useRef(0);
  const maxRetries = 10;
  const retryDelay = 200;

  useEffect(() => {
    if (location.hash) {
      lastHash.current = location.hash.slice(1);
      retryCount.current = 0;
    }

    const scrollToElement = () => {
      if (lastHash.current && document.getElementById(lastHash.current)) {
        document.getElementById(lastHash.current)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        lastHash.current = '';
        retryCount.current = 0;
      } else if (lastHash.current && retryCount.current < maxRetries) {
        retryCount.current += 1;
        setTimeout(scrollToElement, retryDelay);
      } else if (retryCount.current >= maxRetries) {
        lastHash.current = '';
        retryCount.current = 0;
      }
    };

    setTimeout(scrollToElement, 300);
  }, [location]);

  useEffect(() => {
    if ((location.state as LocationState)?.scrollTop !== false) window.scrollTo(0, 0);
  }, [location]);

  return null;
}

export default ScrollToAnchor;
